;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ["settlement_id", "account_id", "current_user"],
  data: function data() {
    return {
      loading: false,
      error_message: null,
      selected_bank_account: null,
      filtered_bank_accounts: [],
      original_bank_accounts: [],
      creating: false,
      item: null,
      redirect_url: "/settlements/" + this.settlement_id + "/details",
      id: null,
      banks: [],
      selected_bank: null
    };
  },
  created: function created() {
    this.item = this.$attrs["item"];
    this.id = this.item.id;
  },
  mounted: function mounted() {
    var _this = this;

    $(this.get_modal_name()).on("shown.bs.modal", function () {
      _this.error_message = null;
      _this.selected_bank_account = null;
      _this.selected_bank = null;
      _this.banks = [];
      _this.filtered_bank_accounts = [];
      _this.original_bank_accounts = [];
      _this.load_bank_accounts(_this.item.gateway);
    });

    $(this.get_modal_name()).on("hidden.bs.modal", function () {
      _this.error_message = null;
      _this.selected_bank = null;
      _this.selected_bank_account = null;
      _this.creating = false;
      _this.banks = [];
      _this.filtered_bank_accounts = [];
      _this.original_bank_accounts = [];
    });
  },

  methods: {
    filter_bank_accounts: function filter_bank_accounts() {
      var _this2 = this;

      this.filtered_bank_accounts = this.original_bank_accounts.filter(function (v) {
        return v.bank == _this2.selected_bank;
      });
    },
    get_modal_name: function get_modal_name() {
      return "#exampleModal" + this.item.id;
    },
    get_modal_id: function get_modal_id() {
      return "exampleModal" + this.item.id;
    },

    load_bank_accounts: function load_bank_accounts(gateway) {
      var _this3 = this;

      var url = "/api/settlements/gateway/" + gateway + "/account/" + this.account_id;
      Vue.axios.get(url, {
        params: {
          current_user: this.current_user
        }
      }).then(function (response) {
        _this3.original_bank_accounts = response.data;
        var all_banks = _this3.original_bank_accounts.map(function (v) {
          return v.bank;
        });
        _this3.banks = all_banks.filter(function (x, y) {
          return all_banks.indexOf(x) == y;
        });
      }).catch(function () {
        _this3.bank_accounts = [];
      });
    },
    store: function store(item, list) {
      if (!list.includes(item)) {
        list.push(item);
      }
      return list;
    },
    initiate_settlement: function initiate_settlement() {
      var _this4 = this;

      var msel_bank_account = this.original_bank_accounts.filter(function (v) {
        return v.account_name == _this4.selected_bank_account;
      });
      this.creating = true;
      var payload = {
        account_id: this.account_id,
        bank_account_id: msel_bank_account[0].id,
        destination: msel_bank_account[0].account_number,
        amount: this.item.amount
      };
      var url = "/api/gateway/settlements/" + this.id + "/initiate";

      Vue.axios.post(url, payload).then(function () {
        _this4.creating = false;
        $(_this4.get_modal_name() + " .close").click();
        window.top.location.href = _this4.redirect_url;
      }).catch(function () {
        _this4.creating = false;
        _this4.error_message = "Error initiating Settlement ! Try again later";
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn-sm btn-white",attrs:{"href":"#!","data-toggle":"modal","data-target":_vm.get_modal_name()}},[_vm._v("\n    Settle\n  ")]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":_vm.get_modal_id(),"tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalCenterTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.error_message)?_c('div',{staticClass:"alert alert-warning alert-dismissible fade show text-left",attrs:{"role":"alert"}},[_c('strong',[_vm._v(" "+_vm._s(_vm.error_message))])]):_vm._e(),_vm._v(" "),_c('div',[_c('label',{staticClass:"text-left",attrs:{"for":"bnk"}},[_vm._v("Select Bank")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_bank),expression:"selected_bank"}],staticClass:"form-control",attrs:{"id":"bnk"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_bank=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.filter_bank_accounts()}]}},_vm._l((_vm.banks),function(item,index){return _c('option',{key:index,domProps:{"value":item}},[_vm._v("\n                "+_vm._s(item)+"\n              ")])}),0)]),_vm._v(" "),_c('div',[_c('label',{staticClass:"text-left",attrs:{"for":"bnk"}},[_vm._v("Select Account")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_bank_account),expression:"selected_bank_account"}],staticClass:"form-control",attrs:{"id":"bnk"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_bank_account=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.filtered_bank_accounts),function(data,index){return _c('option',{key:index,domProps:{"value":data.account_name}},[_vm._v("\n                "+_vm._s(data.account_name)+"\n              ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n            Close\n          ")]),_vm._v(" "),(!_vm.creating && _vm.selected_bank_account)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.initiate_settlement()}}},[_vm._v("\n            Settle\n          ")]):_vm._e(),_vm._v(" "),(_vm.creating)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"}},[_vm._v("\n            Please wait...\n          ")]):_vm._e()])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalCenterTitle"}},[_vm._v("\n            Settle to Bank Account\n          ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ae8cf1b", __vue__options__)
  } else {
    hotAPI.reload("data-v-5ae8cf1b", __vue__options__)
  }
})()}